import { useStorage } from '@vueuse/core'
import { middlewareInstructions, MiddlewareAction } from './types'
import { StorageKey } from '~/constants/storage'

export default function hasCheckoutId(): middlewareInstructions {
  const id = useStorage(StorageKey.CHECKOUT_ID, '')
  if (!id.value)
    return {
      to: { name: 'checkout-sign-in' },
      actions: MiddlewareAction.LOGOUT,
    }
  return { to: { name: '' } }
}
